module.exports = __webpack_public_path__ + "img/map-marker_2x.6e4a98b.png";